// Welche ROLLE ein Interface im Router spielt — die Frage, nach der die
// Detailseite ihre Tabs schneidet (docs/device-management.md → „Die Tabs der
// Detailseite"). Steht hier und nicht in einer Komponente, weil Tab-Leiste,
// Uplink-Tabelle und WLAN-Liste dieselbe Antwort brauchen.

import type { NetworkInterface, WifiNetwork } from "./api-types";

/** Protokolle, mit denen ein Interface eine Leitung nach draußen aufbaut.
 *
 *  Bewusst eine Positivliste über `proto` und nicht die Firewall-Zone `wan`:
 *  die Zone wäre OpenWrts eigene Definition und damit die genauere Quelle,
 *  kostet aber einen zweiten Rohstand-Frame je Aufruf. Der Preis dieser
 *  Abkürzung ist ein statisch konfiguriertes WAN — das fehlt hier. */
const UPLINK_PROTOS = new Set([
  "dhcp",
  "dhcpv6",
  "pppoe",
  "pppoa",
  "qmi",
  "ncm",
  "mbim",
  "wwan",
  "modemmanager",
]);

export function isUplink(iface: NetworkInterface): boolean {
  return UPLINK_PROTOS.has(iface.proto ?? "");
}

/** Ein `sta`-Interface hängt die Box an ein fremdes WLAN — es versorgt keine
 *  Clients, es IST die Leitung. Ohne diese Unterscheidung stand der Uplink des
 *  Routers als gewöhnliches offenes WLAN in der Liste und war einen Klick vom
 *  Löschen entfernt. */
export function isStation(net: WifiNetwork): boolean {
  return net.mode === "sta";
}
